<template>
  <div class="settings-view flex flex-col">
    <page-header :title="tr('Settings')">
      <form-step-tab :items="formStepTabs" stretch />

      <template #buttons>
        <ui-button v-if="hasSaveButton" :disabled="isSaving" @click="() => save()">
          <loader-circle-icon v-if="isSaving" class="animate-spin" />
          {{ tr('Save') }}
        </ui-button>
        <ui-button v-if="$route.path === '/settings/team'" @click="() => openInviteModal()">
          <user-plus-icon />
          {{ tr('Invite a teammember') }}
        </ui-button>
      </template>
    </page-header>

    <router-view v-slot="{ Component }">
      <component :is="Component" ref="childView" />
    </router-view>
  </div>
</template>

<script>
import { LoaderCircle, UserPlus } from '@lucide/vue';

import FormStepTab from '@/ui/components/FormStepTab.vue';
import InviteMemberModal from '@/ui/components/InviteMemberModal.vue';
import PageHeader from '@/ui/components/PageHeader.vue';

export default {
  name: 'SettingsView',
  components: {
    FormStepTab,
    LoaderCircleIcon: LoaderCircle,
    PageHeader,
    UserPlusIcon: UserPlus,
  },
  data: () => ({
    hasSaveButton: false,
  }),
  computed: {
    isSaving() {
      return this.$refs['childView'] && this.$refs['childView'].isLoading;
    },
    formStepTabs() {
      return [
        {
          label: this.tr('Organization'),
          link: '/settings/account',
        },
        {
          label: this.tr('Billing and payment'),
          link: '/settings/billing-and-payment',
        },
        {
          label: this.tr('Payment history'),
          link: '/settings/payment-history',
        },
        {
          label: this.tr('Team'),
          link: '/settings/team',
        },
      ];
    },
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.hasSaveButton = this.$refs['childView'] && typeof this.$refs['childView'].save === 'function';
        });
      },
    },
  },
  methods: {
    openInviteModal() {
      this.$fullscreenModal.open(
        this,
        InviteMemberModal,
        {},
        {
          componentListeners: {
            invited: () => {
              if (this.$refs.childView && typeof this.$refs.childView.updateContent === 'function') {
                this.$refs.childView.updateContent();
              }
            },
          },
        },
      );
    },
    save() {
      this.$refs['childView'].save();
    },
  },
};
</script>
